import { render, staticRenderFns } from "./AbrirCotacaoNoMenuDeContexto.vue?vue&type=template&id=363a319a"
import script from "./AbrirCotacaoNoMenuDeContexto.vue?vue&type=script&lang=js"
export * from "./AbrirCotacaoNoMenuDeContexto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports